/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UpdateActivityCommentRequest
 */
export interface UpdateActivityCommentRequest {
  /**
   *
   * @type {string}
   * @memberof UpdateActivityCommentRequest
   */
  activityCommentId: string;
  /**
   *
   * @type {string}
   * @memberof UpdateActivityCommentRequest
   */
  activityId: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof UpdateActivityCommentRequest
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof UpdateActivityCommentRequest
   */
  createdBy?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateActivityCommentRequest
   */
  text?: string;
  /**
   *
   * @type {boolean}
   * @memberof UpdateActivityCommentRequest
   */
  isPinned?: boolean;
  /**
   *
   * @type {string}
   * @memberof UpdateActivityCommentRequest
   */
  replyTo?: string;
}

/**
 * Check if a given object implements the UpdateActivityCommentRequest interface.
 */
export function instanceOfUpdateActivityCommentRequest(
  value: object,
): value is UpdateActivityCommentRequest {
  if (
    !("activityCommentId" in value) ||
    value["activityCommentId"] === undefined
  )
    return false;
  if (!("activityId" in value) || value["activityId"] === undefined)
    return false;
  return true;
}

export function UpdateActivityCommentRequestFromJSON(
  json: any,
): UpdateActivityCommentRequest {
  return UpdateActivityCommentRequestFromJSONTyped(json, false);
}

export function UpdateActivityCommentRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): UpdateActivityCommentRequest {
  if (json == null) {
    return json;
  }
  return {
    activityCommentId: json["activityCommentId"],
    activityId: json["activityId"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
    text: json["text"] == null ? undefined : json["text"],
    isPinned: json["isPinned"] == null ? undefined : json["isPinned"],
    replyTo: json["replyTo"] == null ? undefined : json["replyTo"],
  };
}

export function UpdateActivityCommentRequestToJSON(
  json: any,
): UpdateActivityCommentRequest {
  return UpdateActivityCommentRequestToJSONTyped(json, false);
}

export function UpdateActivityCommentRequestToJSONTyped(
  value?: UpdateActivityCommentRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    activityCommentId: value["activityCommentId"],
    activityId: value["activityId"],
    createdAt: value["createdAt"],
    createdBy: value["createdBy"],
    text: value["text"],
    isPinned: value["isPinned"],
    replyTo: value["replyTo"],
  };
}
